export const civilities = [
  {
    id: 'radio-1',
    value: 'Monsieur',
    label: 'Monsieur',
    name: 'radio-option',
  },
  {
    id: 'radio-2',
    value: 'Madame',
    label: 'Madame',
    name: 'radio-option',
  },
]
